// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__l1RW5","rotate-forever":"Spinner_rotate-forever__abZN_"};